module.exports = __webpack_public_path__ + "media/买货币基金.42f2117.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/买货币基金.mp4
// module id = oAIR
// module chunks = 3